import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

var Radio = (_param)=>{
    var { children , className , 'data-t': dataT  } = _param, htmlInputProps = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        'data-t'
    ]);
    return /*#__PURE__*/ React.createElement("label", {
        className: classnames('radio', className),
        "data-t": dataT
    }, /*#__PURE__*/ React.createElement("input", swcHelpers.extends({
        type: "radio",
        className: "radio__input"
    }, htmlInputProps)), children);
};

export { Radio };
//# sourceMappingURL=Radio.js.map
